type NavigatorUAData = { platform?: string }

function detectPlatform() {
  if (typeof navigator === "undefined") return ""

  const uaData = (navigator as Navigator & { userAgentData?: NavigatorUAData })
    .userAgentData

  return uaData?.platform || navigator.platform || ""
}

export const isMac = /mac|iphone|ipad|ipod/i.test(detectPlatform())

/**
 * Display token for the platform's shortcut modifier — render it in a `Kbd`.
 */
export const MODIFIER_KEY = isMac ? "⌘" : "Ctrl"

/**
 * Whether the platform's shortcut modifier is held: Cmd on macOS, Ctrl
 * elsewhere. Use instead of `metaKey || ctrlKey`, which lets Ctrl trigger
 * Cmd shortcuts on a Mac.
 *
 * Alt rules the chord out off macOS, where Windows reports AltGr as Ctrl+Alt:
 * on layouts that type a character with AltGr (`AltGr+ß` for `\` on a German
 * keyboard), a shortcut matching it would swallow the character.
 */
export function hasModifierKey(
  event: Pick<KeyboardEvent, "metaKey" | "ctrlKey" | "altKey">
) {
  return isMac ? event.metaKey : event.ctrlKey && !event.altKey
}
